import { DashboardService } from "../dashboardService";
import { LocalStorageService } from "src/services/localStorageService";
import { CreationDateSortOptions, LocalStorageKeys, TransferOrderColumnHeader } from "src/enums";
import { TransferOrdersFilters } from "src/types";

class TransferOrderDashService extends DashboardService<
  TransferOrderColumnHeader,
  TransferOrdersFilters,
  CreationDateSortOptions,
  undefined
> {
  constructor(localStorageService: LocalStorageService) {
    super(localStorageService, LocalStorageKeys.TRANSFER_ORDER_DASH_SETTINGS);
  }
}

export { TransferOrderDashService };
